import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import { selectedRechargableAmnt, setShowRecargeSection } from "../../redux/recharge/recharge.action";
import { store } from "../../redux/store";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import '../RechargeComponent/browseplans.css';

const httpClient = axios.create();
class BrowsePlan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            planTypeList: [],
            selectedPlan: '',
            circlrBasedPlanHeaders: [],
            planList: [],
            circlrBasedPlans: '',
            operator: ''
        }
    }


    componentDidMount() {
        this.check();
    }
    componentWillUnmount() {
    }



    check = () => {
        setInterval(() => {
            if (this.props.browsePlans != '' &&
                this.props.browsePlans != undefined &&
                this.props.browsePlans != null &&
                this.props.browsePlans != 'loading' &&
                this.props.browsePlans != 'error'){
                
            }else{
                this.setState({
                    selectedPlan: '3G/4G'
                })
            }

        }, 100);
    }



    selectPlan = (plan) => {
        this.setState({
            selectedPlan: plan
        })

        var planList = this.props.browsePlans.circlrBasedPlans.get(plan);
        this.props.browsePlans.planList = planList;
        // this.setState({
        //     planList: planList
        // })
    }

    backToTxnHistory = () => {
        store.dispatch(setShowRecargeSection('txnHistory'))
    }

    selectAmountToRecharge(event, amount) {
        event.preventDefault();
        store.dispatch(selectedRechargableAmnt(amount));
    }


    errorMessageCall = (message) => {
        this.setState({
            displayErrorMsg: message
        })
    }

    render() {
        console.log(JSON.stringify(this.props.browsePlans))

        return (

            <div id="browseplan">
                {
                    (this.props.browsePlans != '' &&
                        this.props.browsePlans != undefined &&
                        this.props.browsePlans != null &&
                        this.props.browsePlans != 'loading' &&
                        this.props.browsePlans != 'error') ?
                        <div class="head">

                            <div class="hright">
                                <button class="close btn waves-effect waves-light"
                                    onClick={this.backToTxnHistory}>

                                </button>
                            </div>

                            {(this.props.browsePlans.operator != undefined && this.props.browsePlans.operator != '') ?
                                <h3>Browse Plans - {this.props.browsePlans.operator}</h3> :
                                <h3>Browse Plans</h3>
                            }
                        </div> :
                        <div class="head">

                            <div class="hright">
                                <button class="close btn waves-effect waves-light"
                                    onClick={this.backToTxnHistory}>

                                </button>
                            </div>
                            <h3>Browse Plans</h3>
                        </div>

                }
                {
                    this.props.browsePlans != '' &&
                    this.props.browsePlans != undefined &&
                    this.props.browsePlans != null &&
                    this.props.browsePlans != 'loading' &&
                    this.props.browsePlans != 'error' &&
                    <div class="planbox">
                        <div class="plantype">
                            <ul>
                                {
                                    this.props.browsePlans.circlrBasedPlanHeaders != undefined && this.props.browsePlans.circlrBasedPlanHeaders.length > 0 && this.props.browsePlans.circlrBasedPlanHeaders.map(plan => (
                                        <li class={this.state.selectedPlan == plan && 'active'} onClick={e => { this.selectPlan(plan) }}>{plan}</li>
                                    ))}


                            </ul>
                        </div>
                        {
                            <div class="planhead">
                                <div class="row">
                                    <div class="col-6 col-sm-7">
                                        <h4>Description</h4>
                                    </div>
                                    <div class="col-3">
                                        <h4>Validity</h4>
                                    </div>
                                    <div class="col-3 col-sm-2">
                                        <h4>Price</h4>
                                    </div>
                                </div>
                            </div>}
                        {
                            this.props.browsePlans.planList != undefined &&
                            this.props.browsePlans.planList.length > 0 &&
                            this.props.browsePlans.planList.map(plan => (
                                <div class="planrow">
                                    <div class="row">
                                        <div class="col-6 col-sm-7">
                                            <p>{plan.desc}</p>
                                        </div>
                                        <div class="col-3">
                                            <p>{plan.validity}</p>
                                        </div>
                                        <div class="col-3 col-sm-2">
                                            <button type="button" class="lbbtn" onClick={e => { this.selectAmountToRecharge(e, plan.rs) }}>₹{plan.rs}</button>
                                        </div>
                                    </div>
                                </div>
                            ))

                        }


                    </div>
                }
                {
                    this.props.browsePlans == 'loading' &&
                    <div>

                        Loading Plans...

                    </div>
                }



                {
                    (this.props.browsePlans == 'error' ||
                        this.props.browsePlans == '' ||
                        this.props.browsePlans == undefined ||
                        this.props.browsePlans == null) &&
                    <div class='valid-error'>

                        Something went wrong.please try later!

                    </div>
                }


            </div>



        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, token, agentInfo },
        rechargeReduce: { rechargeMobileNo, selectedCircle, selectedOperator, browsePlans }

    }
) => ({
    errorMessage, loginErrorMessage, phone, token, agentInfo, rechargeMobileNo, selectedCircle, selectedOperator, browsePlans
});

export default connect(mapStateToProps, null)(BrowsePlan);
